import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from "eduid-hooks";
import { useEffect } from "react";
import { useParams } from "react-router";
import loginSlice from "slices/Login";
import resetPasswordSlice from "slices/ResetPassword";
import { EmailLinkSent } from "./EmailLinkSent";
import { HandleExtraSecurities } from "./HandleExtraSecurities";
import { ProcessCaptcha, ResetPasswordCaptcha } from "./ResetPasswordCaptcha";
import { ResetPasswordConfirmEmail } from "./ResetPasswordConfirmEmail";
import { ResetPasswordEnterCode } from "./ResetPasswordEnterCode";
import { ResetPasswordEnterEmail } from "./ResetPasswordEnterEmail";
import { ResetPasswordLocked } from "./ResetPasswordLocked";
import { ResetPasswordSuccess, SetNewPassword } from "./SetNewPassword";
export function ResetPasswordApp() {
    const params = useParams();
    const dispatch = useAppDispatch();
    const loginRef = useAppSelector((state) => state.login.ref);
    const next_page = useAppSelector((state) => state.resetPassword.next_page);
    useEffect(() => {
        if (next_page === undefined) {
            if (loginRef === undefined && params.ref !== undefined) {
                dispatch(loginSlice.actions.addLoginRef({ ref: params.ref, start_url: globalThis.location.href }));
            }
            dispatch(resetPasswordSlice.actions.setNextPage("ASK_FOR_EMAIL_OR_CONFIRM_EMAIL"));
        }
    }, [dispatch, loginRef, next_page, params]);
    return (_jsxs(_Fragment, { children: [next_page === "ASK_FOR_EMAIL_OR_CONFIRM_EMAIL" && _jsx(AskForEmailOrConfirmEmail, {}), next_page === "RESET_PW_CONFIRM_EMAIL" && _jsx(ResetPasswordConfirmEmail, {}), next_page === "RESET_PW_ENTER_EMAIL" && _jsx(ResetPasswordEnterEmail, {}), next_page === "RESET_PW_ENTER_CODE" && _jsx(ResetPasswordEnterCode, {}), next_page === "RESET_PW_CAPTCHA" && _jsx(ResetPasswordCaptcha, {}), next_page === "PROCESS_CAPTCHA" && _jsx(ProcessCaptcha, {}), next_page === "RESET_PW_LOCKED" && _jsx(ResetPasswordLocked, {}), next_page === "EMAIL_LINK_SENT" && _jsx(EmailLinkSent, {}), next_page === "HANDLE_EXTRA_SECURITIES" && _jsx(HandleExtraSecurities, {}), next_page === "SET_NEW_PASSWORD" && _jsx(SetNewPassword, {}), next_page === "RESET_PW_SUCCESS" && _jsx(ResetPasswordSuccess, {})] }));
}
function AskForEmailOrConfirmEmail() {
    const email_address = useAppSelector((state) => state.resetPassword.email_address);
    const email_status = useAppSelector((state) => state.resetPassword.email_status); // Has an e-mail been sent?
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (email_status === undefined || !email_status) {
            if (email_address) {
                dispatch(resetPasswordSlice.actions.setNextPage("RESET_PW_CONFIRM_EMAIL"));
            }
            else {
                dispatch(resetPasswordSlice.actions.setNextPage("RESET_PW_ENTER_EMAIL"));
            }
        }
    }, [email_status, email_address, dispatch]);
    return null;
}
